import { ToolTipModel } from '../../common/CustomTooltip';

const progressScoreTooltip: ToolTipModel = {
	title: 'About the Financial Progress Score',
	content: [
		'The scoring system and personas are informed by extensive research into a wide range of financial situations, behaviours, and attitudes.',
		'Your score provides a snapshot of your overall financial wellbeing and reflects progress across Personal, Business, Wealth, and Estate, based on your responses.',
		'Scores may change over time as your financial position evolves.'
	]
};

export default progressScoreTooltip;
